import { Tabs, Typography } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react'

import { PageHeader, PageShell } from '@/components/page-shell'
import { ProjectOverview } from '@/pages/project-dashboard'
import { DevicesList } from '@/pages/devices/list'
import { LicensesList } from '@/pages/licenses/list'
import { ActivationsList } from '@/pages/activations/list'
import { ProjectConfig } from '@/pages/projects/config'
import { useMessage } from '@/providers/message-provider'

const { Text } = Typography

/**
 * 项目详情页（F5-F9）
 *
 * 顶部：项目名 + code + 状态 + 返回按钮
 * Tab 切换：
 *   1. 概览（F5）— 统计看板 + 近期激活
 *   2. 设备（F6）— 设备列表
 *   3. 序列号（F7）— 序列号列表 + 发卡/换机/吊销操作
 *   4. 激活日志（F8）— 操作日志
 *   5. 配置（F9）— 项目配置 + 密钥轮换
 */

export default function ProjectShowPage() {
  const { code = '' } = useParams<{ code: string }>()
  const navigate = useNavigate()
  const message = useMessage()
  const [activeTab, setActiveTab] = useState('overview')

  if (!code) {
    message.error('缺少项目 code')
    navigate('/projects')
    return null
  }

  const tabs = [
    {
      key: 'overview',
      label: '概览',
      children: <ProjectOverview projectCode={code} />
    },
    {
      key: 'devices',
      label: '设备',
      children: <DevicesList projectCode={code} />
    },
    {
      key: 'licenses',
      label: '序列号',
      children: <LicensesList projectCode={code} />
    },
    {
      key: 'activations',
      label: '激活日志',
      children: <ActivationsList projectCode={code} />
    },
    {
      key: 'config',
      label: '配置',
      children: <ProjectConfig projectCode={code} />
    }
  ]

  return (
    <PageShell width="wide">
      <PageHeader
        title="项目详情"
        subtitle="查看当前项目的概览、设备、序列号、激活日志与运行配置。"
        onBack={() => navigate('/projects')}
        meta={
          <Text>
            项目标识 <span className="app-inline-code">{code}</span>
          </Text>
        }
      />

      <div className="app-tabs-card">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabs}
          destroyOnHidden={false}
          size="large"
          style={{ background: 'transparent' }}
        />
      </div>
    </PageShell>
  )
}
